export const tribes = {
  black: [
    'Assassin',
    'Cleric',
    'Demon',
    'Gorgon',
    'Horror',
    'Imp',
    'Minion',
    'Rat',
    'Shade',
    'Specter',
    'Thrull',
    'Vampire',
    'Zombie',
  ],

  green: [
    'Elf',
    'Human',
    'Troll',
    'Dryad',
    'Kavu',
    'Wolf',
    'Treefolk',
    'Wurm',
    'Druid',
    'Beast',
    'Insect',
    'Spider',
    'Squirrel',
  ],
  white: [
    'Angel',
    'Knight',
    'Soldier',
    'Rebel',
    'Cleric',
    'Monk',
    'Animal',
    'Kitsune',
    'Kor',
    'Wizard',
    'Aven',
    'Human',
    'Samurai',
  ],
};

export const abilities = {
  black: [
    'Killing creatures, usually nonblack - Terror',
    ' Draw cards at a cost other than mana',
    '-X/-X - Last Gasp,',
    'Discard - Mind Rot',
    'Swamp power - Cabal Coffers',
    'Life Loss - Cackling Imp,',
    'Life drain - Soul Feast',
    'Universal tutoring - Diabolic Tutor',
  ],
  green: [
    'Deathtouch (shared with black)',
    'Hexproof (shared with blue)',
    'Flash (shared with blue and black)',
    'Vigilance (shared with white)',
    'Trample (shared with red)',
    'Haste (shared with red and black)',
    'Reach',
    'Regeneration',
  ],

  white: [
    'Lifelink - Kjeldoran Gargoyle',
    'Flying - Suntail Hawk',
    'First strike - Youthful Knight',
    'Double strike - Skyhunter Skirmisher',
    'Exalted - Akrasan Squire',
    'Global kill - Wrath of God',
    'Enchantment removal - Demystify',
    'Taxation - Ghostly Prison',
  ],
};

export const gameplay = {
  black: [
    "Black usually doesn't do well in the late game, rather, it finds innovative ways to get superior positions early on so that it can rule in the midgame. Often, this means you will sacrifice life for cards for an early advantage. Card advantage plays a very big role, though at the loss of life. It can play very well by itself through corruption effects and work with other colors all equally well. Reanimation decks have always been a favorite, finding ways to dump big, expensive creatures into the graveyard early and then play them from there for cheap. Animate Dead and Zombify both work well for this. Black is also known for it's discard effects.",
    'Black is one of the five colors of mana in Magic. It is drawn from the power of swamps and embodies the principles of parasitism and amorality (though not necessarily immorality). The mana symbol for Black is represented by a skull. On the color pie, it is the ally of blue and red, and the enemy of white and green. Black seeks power through ruthlessness or opportunity.',
  ],
  green: [
    'Green is a strong color, centered around brute force. It contains many large creatures with trample. Green contains many high mana cost spells, but also has many ways to accelerate its mana to cast them early. Common themes include ferocity, brute strength, instinct, and primal rage as well as harmony, tranquility and natural law. The pulse of life is the power of green mana, and as such common creature types include living trees, tiny forest creatures, and giant beasts',
    'Green is one of the five colors of mana in Magic. It is drawn from the power of forests and embodies the principles of instinct and interdependence. The mana symbol for Green is represented by a tree. On the Color Pie, it is the ally of white and red, and the enemy of blue and black. Green seeks growth through acceptance, though it has also previously been described as seeking harmony or acceptance through growth, or growth through wisdom.',
  ],
  white: [
    "Alone, white is commonly known as an aggressive color. Packed with effective cards such as Savannah Lions, Knight of the Holy Nimbus, and Isamaru, Hound of Konda, white can quickly outnumber the opponent with too many threats to handle, and by the time he can handle it, he's already lost. Combined with another color, white is well-suited to play the role of a supporter to whatever role the other color wishes to play. It is commonly known to be effective at controlling the game with blue. For black, they have a tendency to share in life gain. Red is more than happy to adopt the cheap, effective creatures white holds to get even more aggressive, though this makes it more crucial to get both colors of mana very quickly (say from Battlefield Forge).",
    'White is one of the five colors of mana in Magic. It is drawn from the plains and embodies the principles of morality and order. The mana symbol for White is represented by a sun. On the color pie, it is allied with green and blue, and is enemies with black and red. White seeks peace through structure.',
  ],
};

export const facts = {
  general: [
    'In Magic: The Gathering, a Planeswalker is a powerful mage who is able to travel across the planes of existence. There are infinite worlds across the Multiverse, and Planeswalkers are unique in their ability to move from one world to the next, expanding their knowledge and power through the experiences they collect there.',
    'Planeswalkers usually have three abilities: one ability that adds loyalty counters as a cost for a small benefit, one that removes a small number of counters as a cost for a larger effect, and one that removes a large number of loyalty counters for a big effect.',
  ],
  black: [
    "A black card is defined as any card that has {B} in its mana cost or any card that has a black color indicator. Black is oriented on obtaining power — ultimate power at any cost. In the game of Magic, this means that black cards sometimes use resources that other colors don't dare touch. Sacrificing permanents and paying life is certainly do-able for the right effect.",
  ],
  green: [
    'A green card is defined as any card that has {G} in its mana cost or any card that has a Green color indicator. Green is the most efficient color as far as creatures are concerned, with one mana creatures that have abilities such as Llanowar Elves and Scryb Sprites to the vanilla 2/2 Grizzly Bears costing two mana (only one of which is Green).',
  ],

  white: [
    'A white card is defined as any card that has {W} in its mana cost or any card that has a white color indicator. White is an inherently defensive color. One of these defensive mechanics is Life Gain. This comes in the form of life gain directly to the player, life gain to a creature (also known as healing), and damage prevention.',
  ],
};
